import { render, staticRenderFns } from "./FactorScore.vue?vue&type=template&id=4603ccb4&scoped=true&"
import script from "./FactorScore.vue?vue&type=script&lang=ts&"
export * from "./FactorScore.vue?vue&type=script&lang=ts&"
import style0 from "./FactorScore.vue?vue&type=style&index=0&id=4603ccb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603ccb4",
  null
  
)

export default component.exports